function calculateImcReturned(weight:number, height:number): number {
  const heightm = +Number(height).toString().substring(0,4)/100;
  const weightKg = weight / Math.pow(heightm,2) * 1000;
  const imc = +Number(weightKg).toString().substring(0,4)/100;
  return Number.isNaN(imc)|| !Number.isFinite(imc) ? 0 : Number(imc);
}

export default calculateImcReturned;